<span>{{userFullName || username}}</span>
